import FunnelPage from "./FunnelPage";

export default function FunnelUniversity() {
  return (
    <FunnelPage
      funnelKey="university_pathway"
      eyebrow="KISSED University of Healing Arts & Sciences"
      headline="Your calling deserves a curriculum."
      body="KUHAS is preparing four pathways for the next cohort — Trichology, Functional Wellness Practitioner, Mind-Body Coaching, and Comfort Care. Be the first to know when applications open."
      comingNext="Cohort applications open soon"
      noteLabel="What program interests you? (optional)"
      notePlaceholder="Trichology, functional wellness, coaching, comfort care…"
      testidPrefix="funnel-university"
    />
  );
}
